import React from "react";

export default function HomeIcon() {
  return (
    <svg
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M19.6248 8.06766L17.542 6.24353L17.5386 2.57483C17.5384 2.27482 17.2974 2.03177 17.0003 2.03177H14.7186C14.4212 2.03177 14.1803 2.27506 14.1803 2.57531V3.29915L10.725 0.273512C10.3085 -0.0911705 9.68989 -0.0911705 9.27343 0.273512L0.405542 8.03929C0.0255102 8.372 -0.120454 8.93165 0.110994 9.38263C0.454356 10.0517 1.298 10.1827 1.82495 9.72135L9.99897 2.56257L18.173 9.72135C18.382 9.90429 18.6406 9.9942 18.8985 9.9942C19.2045 9.9942 19.5093 9.86751 19.7267 9.61942C20.1277 9.16267 20.0822 8.46816 19.6248 8.06766Z"
        fill="#33403E"
      />
      <path
        d="M17.5413 18.2583L17.5386 10.5877C17.3058 10.3995 10.2247 4.19245 9.99944 3.99509C9.7737 4.19293 2.69406 10.3981 2.46095 10.587L2.46357 18.2583H1.31466C1.11679 18.2583 0.956299 18.4203 0.956299 18.6201V19.6382C0.956299 19.838 1.11679 20 1.31466 20H13.0387C13.0425 19.0197 12.9323 17.6273 12.4201 17.1186C11.2774 17.2325 8.57622 17.3273 7.36374 15.7149C5.73456 13.548 5.80361 10.9106 6.36985 8.82154C9.50011 11.2404 11.7291 9.92712 13.3585 12.0941C14.0179 12.971 14.0805 13.9696 13.9264 14.8512C12.2711 12.9967 10.0604 11.8289 7.85973 11.6174C13.5969 14.705 14.3112 18.1982 14.5865 19.9998H18.6914C18.8892 19.9998 19.0497 19.8377 19.0497 19.638V18.6201C19.0497 18.4203 18.8892 18.2583 18.6914 18.2583H17.5413Z"
        fill="#33403E"
      />
    </svg>
  );
}
